import { useEffect } from "react";

// Screen Wake Lock — kým beží časovač alebo stopky, obrazovka telefónu nezhasne a nezamkne sa
// (inak sa uprostred planku zamkne displej a meranie sa nedá zastaviť bez odomykania).
//
// Detaily, ktoré treba dodržať:
//  • Prehliadač lock SÁM uvoľní, keď stránka prestane byť viditeľná (prepnutie appky, zhasnutie
//    obrazovky tlačidlom) — preto ho pri návrate na stránku (visibilitychange) berieme znova.
//  • `request` môže odmietnuť (šetrič batérie, politika prehliadača) alebo API vôbec neexistovať
//    (iOS < 16.4, nezabezpečený kontext) — vtedy sa ticho nič nedeje, časovač beží ako doteraz.
//  • Lock sa uvoľní pri odmountovaní aj hneď ako `active` klesne na false.
export function useWakeLock(active) {
  useEffect(() => {
    if (!active || typeof navigator === "undefined" || !navigator.wakeLock) return undefined;
    let lock = null;
    let cancelled = false;
    const acquire = async () => {
      if (cancelled || lock || document.visibilityState !== "visible") return;
      try {
        const l = await navigator.wakeLock.request("screen");
        if (cancelled) { l.release().catch(() => {}); return; }
        lock = l;
        // po automatickom uvoľnení (skrytie stránky) si nedrž mŕtvy objekt — nech sa dá vziať znova
        l.addEventListener("release", () => { if (lock === l) lock = null; });
      } catch (e) { /* odmietnuté alebo nepodporované — časovač beží aj bez zámku */ }
    };
    const onVisible = () => { if (document.visibilityState === "visible") acquire(); };
    acquire();
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      cancelled = true;
      document.removeEventListener("visibilitychange", onVisible);
      if (lock) { lock.release().catch(() => {}); lock = null; }
    };
  }, [active]);
}
